/* Aankondigingsbalk als doorlopende loper (15-09).
   Past de tekst niet op het scherm, dan schuift hij rustig naar links en begint daarna
   weer vooraan. Past hij wél, dan gebeurt er niets en blijft hij gewoon staan.
   De kopie is aria-hidden, zodat schermlezers de tekst één keer voorlezen. */
(function () {
  var SNELHEID = 45; /* px per seconde */

  function bouw(shell) {
    if (shell.dataset.marquee === 'bezig') return;
    var origineel = shell.dataset.marqueeHtml || shell.innerHTML;
    shell.dataset.marqueeHtml = origineel;

    /* eerst terug naar de gewone staat, zodat we eerlijk kunnen meten */
    shell.classList.remove('is-marquee');
    shell.innerHTML = origineel;
    if (shell.scrollWidth <= shell.clientWidth + 2) return;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    shell.dataset.marquee = 'bezig';
    var track = document.createElement('div');
    track.className = 'ann-track';
    track.innerHTML = origineel;
    var kopie = track.cloneNode(true);
    kopie.setAttribute('aria-hidden', 'true');
    shell.innerHTML = '';
    shell.appendChild(track);
    shell.appendChild(kopie);
    shell.classList.add('is-marquee');

    var duur = Math.max(8, track.getBoundingClientRect().width / SNELHEID);
    track.style.animationDuration = duur + 's';
    kopie.style.animationDuration = duur + 's';
    delete shell.dataset.marquee;
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.announce .shell'), bouw);
  }
  var wacht;
  function opnieuw() { clearTimeout(wacht); wacht = setTimeout(start, 200); }

  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', start);
  else start();
  addEventListener('load', start);
  addEventListener('resize', opnieuw);
  document.addEventListener('shopify:section:load', start);
})();
